// extracted by css-extract-rspack-plugin
export default {"blockImageDialog":"style_blockImageDialog__eTklG","blockImageWrap":"style_blockImageWrap__js5Bz","btnDownload":"style_btnDownload__Q_fgA"};